import React from "react";
import { ChevronRight, Plus } from "lucide-react";

const CasesTable = ({
  cases,
  filteredBorrowers,
  paginatedBorrowers,
  sortConfig,
  handleSort,
  handleCaseSelect,
  openNewCaseModal,
  searchTerm,
}) => {
  return (
    <div className="dark:bg-slate-900 bg-white border dark:border-slate-800 border-gray-200 rounded-lg overflow-hidden overflow-x-auto transition-colors duration-300">
      <table className="w-full text-left text-sm">
        <thead>
          <tr className="border-b dark:border-slate-800 border-gray-200 dark:bg-slate-900/50 bg-gray-50 dark:text-slate-400 text-gray-700">
            <th
              className="p-4 font-medium cursor-pointer hover:bg-gray-100 dark:hover:bg-slate-800/50 transition-colors"
              onClick={() => handleSort("caseNumber")}
            >
              Case Number{" "}
              {sortConfig.key === "caseNumber" &&
                (sortConfig.direction === "ascending" ? "↑" : "↓")}
            </th>
            <th
              className="p-4 font-medium cursor-pointer hover:bg-gray-100 dark:hover:bg-slate-800/50 transition-colors"
              onClick={() => handleSort("name")}
            >
              Borrower{" "}
              {sortConfig.key === "name" &&
                (sortConfig.direction === "ascending" ? "↑" : "↓")}
            </th>
            <th className="p-4 font-medium">Loan Type</th>
            <th
              className="p-4 font-medium cursor-pointer hover:bg-gray-100 dark:hover:bg-slate-800/50 transition-colors"
              onClick={() => handleSort("loanAmount")}
            >
              Loan Amount{" "}
              {sortConfig.key === "loanAmount" &&
                (sortConfig.direction === "ascending" ? "↑" : "↓")}
            </th>
            <th
              className="p-4 font-medium cursor-pointer hover:bg-gray-100 dark:hover:bg-slate-800/50 transition-colors"
              onClick={() => handleSort("date")}
            >
              Date{" "}
              {sortConfig.key === "date" &&
                (sortConfig.direction === "ascending" ? "↑" : "↓")}
            </th>
            <th
              className="p-4 font-medium cursor-pointer hover:bg-gray-100 dark:hover:bg-slate-800/50 transition-colors"
              onClick={() => handleSort("status")}
            >
              Status{" "}
              {sortConfig.key === "status" &&
                (sortConfig.direction === "ascending" ? "↑" : "↓")}
            </th>
            <th className="p-4 font-medium"></th>
          </tr>
        </thead>
        <tbody className="divide-y dark:divide-slate-800 divide-gray-100">
          {cases.length === 0 ? (
            <tr>
              <td colSpan={7} className="py-10">
                <div className="flex flex-col items-center gap-3 text-center animate-fade-in">
                  <div className="w-12 h-12 rounded-full bg-yellow-100 dark:bg-yellow-600/20 border border-yellow-200 dark:border-yellow-500/40 flex items-center justify-center text-yellow-600 dark:text-yellow-300">
                    <Plus className="w-5 h-5" />
                  </div>
                  <p className="text-base font-medium dark:text-white text-gray-900">Welcome!</p>
                  <p className="text-sm dark:text-slate-400 text-gray-600 max-w-md">
                    Click "New Case" to start.
                  </p>
                  <button
                    onClick={openNewCaseModal}
                    className="px-4 py-2 rounded-lg bg-yellow-600 text-white font-medium hover:bg-yellow-700 transition-colors"
                  >
                    Create new case
                  </button>
                </div>
              </td>
            </tr>
          ) : filteredBorrowers.length === 0 ? (
            <tr>
              <td className="p-4 dark:text-slate-400 text-slate-600" colSpan={7}>
                No cases match "{searchTerm.trim()}".
              </td>
            </tr>
          ) : (
            (paginatedBorrowers.length
              ? paginatedBorrowers
              : filteredBorrowers
            ).map((row) => (
              <tr
                key={row.id}
                className="hover:bg-gray-50 dark:hover:bg-slate-800/50 transition-colors group cursor-pointer"
                onClick={() => handleCaseSelect(row)}
              >
                <td className="p-4 dark:text-slate-500 text-gray-700 font-normal">{row.caseNumber}</td>
                <td className="p-4 font-medium dark:text-white text-gray-900 flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full dark:bg-slate-800 bg-gray-200 flex items-center justify-center dark:text-slate-400 text-gray-700 font-medium text-sm">
                    {row.name[0]}
                  </div>
                  {row.name}
                </td>
                <td className="p-4 dark:text-slate-400 text-gray-700">{row.loanType}</td>
                <td className="p-4 dark:text-slate-400 text-gray-700 font-normal">{row.loanAmount}</td>
                <td className="p-4 dark:text-slate-400 text-gray-600">
                  {new Date(row.date).toLocaleDateString()}
                </td>
                <td className="p-4">
                  <span
                    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${row.status === "Approved"
                      ? "dark:bg-green-500/10 dark:text-green-400 bg-green-50 text-green-700 border border-green-200 dark:border-transparent"
                      : row.status === "Action Required"
                        ? "dark:bg-red-500/10 dark:text-red-400 bg-red-50 text-red-700 border border-red-200 dark:border-transparent"
                        : "dark:bg-yellow-500/10 dark:text-yellow-400 bg-yellow-50 text-yellow-700 border border-yellow-200 dark:border-transparent"
                      }`}
                  >
                    {row.status}
                  </span>
                </td>
                <td className="p-4 text-right">
                  <ChevronRight className="w-4 h-4 text-gray-400 dark:text-slate-600 group-hover:dark:text-white group-hover:text-gray-700 transition-colors" />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CasesTable;
